// extracted by mini-css-extract-plugin
export default {"nav":"HomeNav_nav__8et9c","inner":"HomeNav_inner__xOUVr","logo":"HomeNav_logo__v3x2T","logoImg":"HomeNav_logoImg__B540C","links":"HomeNav_links__0LPca","tel":"HomeNav_tel__DHMa2"};